import React, { useEffect, useRef } from 'react';

import L from 'leaflet';

const MyMap = (props) => {
    const keySeznam = process.env.REACT_APP_SEZNAM_API_KEY;
    const mapContainerRef = useRef(null);
    const mapRef = useRef(null);

    useEffect(() => {
        if (mapRef.current) return;

        const initialState = process.env.REACT_APP_LANG === 'sk' ? {
            lat: 48.1486050,
            lon: 17.1077090,
            zoom: 11
        } : {
            lat: 50.0805941,
            lon: 14.4285893,
            zoom: 11
        };

        const map = L.map(mapContainerRef.current).setView([initialState.lat, initialState.lon], initialState.zoom);
        mapRef.current = map;

        L.tileLayer(
            "https://{s}.tile.openstreetmap.org/{z}/{x}/{y}.png", {
            name: 'OpenStreetMap',
            attribution: '&copy; <a href=&quot;https://www.openstreetmap.org/copyright&quot;>OpenStreetMap</a> contributors',
            maxZoom: 16,
        }).addTo(map);
        L.tileLayer(
            "https://api.mapy.cz/v1/maptiles/aerial/256/{z}/{x}/{y}?apikey={apiKey}", {
            name: 'Seznam Letecká',
            attribution: '<a href=&quot;https://api.mapy.cz/copyright&quot; target=&quot;_blank&quot;>&copy; Seznam.cz a.s. a další</a>',
            apiKey: keySeznam,
            minZoom: 16,
            maxZoom: 17,
        }).addTo(map);
        L.tileLayer(
            "https://api.mapy.cz/v1/maptiles/names-overlay/256/{z}/{x}/{y}?apikey={apiKey}", {
            name: 'Seznam Popisky',
            attribution: '<a href=&quot;https://api.mapy.cz/copyright&quot; target=&quot;_blank&quot;>&copy; Seznam.cz a.s. a další</a>',
            apiKey: keySeznam,
            minZoom: 16,
            maxZoom: 17,
        }).addTo(map);

        map.on('click', onMapClick);
        setTimeout(function () { map.invalidateSize() }, 1000);
        props.callbackHandler(map);

        return () => {
            map.remove();
            mapRef.current = null;
        };
    }, []);

    function onMapClick(e) {
        const map = mapRef.current;
        if (!map) return;
        map.invalidateSize(true);
        fetch(`https://api.mapy.cz/v1/rgeocode/?lat=${e.latlng.lat}&lon=${e.latlng.lng}&apiKey=${keySeznam}`)
            .then(response => response.json())
            .then(result => {
                if (result.items.length) {
                    const address = result.items[0].name + ', ' + result.items[0].location;
                    if (result.items[0].zip == undefined) {
                        L.popup().setLatLng(e.latlng).setContent("Vyberte prosím přesnější adresu <br>" + address).openOn(map);
                    } else {
                        // Keep the actual clicked point for coordinates - Mapy.cz's matched position can be a different building.
                        props.clickHandler({ ...result.items[0], clickLat: e.latlng.lat, clickLon: e.latlng.lng });
                        L.popup().setLatLng(e.latlng).setContent(address).openOn(map);
                    }
                } else {
                    L.popup().setLatLng(e.latlng).setContent("Adresa nenalezená").openOn(map);
                }
            });
    }

    return (
        <div className="map-container" ref={mapContainerRef}></div>
    )
}

export default MyMap;
